export class FetchClient {
    // FIXME: use axios instead of global.fetch
    static async fetch<T>(url: string): Promise<T> {
        return (await (await global.fetch(url)).json()) as T;
    }
}
